import { render, staticRenderFns } from "./Banners.vue?vue&type=template&id=2f4a30a2&scoped=true&"
import script from "./Banners.vue?vue&type=script&lang=js&"
export * from "./Banners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4a30a2",
  null
  
)

export default component.exports